module.exports = __webpack_public_path__ + "img/肌如初雪套装_03.c6d635f8.jpg";